import { Button } from '@/components/ui/button';
import { Phone, ArrowRight, Star, Users, TrendingUp, Menu } from 'lucide-react';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/AppSidebar';
import kevinHeroOffice from '@/assets/kevin-hero-office.jpg';
const Voice = () => {
  const handleCallNow = () => {
    // TODO: Implement voice call functionality
    console.log('Calling Kevin...');
  };
  const handleLearnMore = () => {
    // TODO: Implement learn more functionality
    console.log('Learn more...');
  };
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main className="flex-1 relative">
          <div className="h-screen overflow-hidden relative">
            {/* Background Image */}
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
              backgroundImage: `url(${kevinHeroOffice})`
            }}>
              <div className="absolute inset-0 bg-black/40"></div>
            </div>
            
            {/* Content */}
            <div className="relative z-10 h-full flex items-center justify-center">
              <div className="container mx-auto px-6 text-center text-white">
                
                {/* Stats Badge */}
                <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium">Available 24/7</span>
                </div>

                {/* Main Headline */}
                <h1 className="text-5xl lg:text-7xl xl:text-8xl font-bold leading-tight mb-8">
                  Transform your sales calls with <span className="text-blue-400">AI Coach Kevin</span>
                </h1>
                
                {/* Subtitle */}
                <p className="text-xl lg:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto">Get instant personalized coaching</p>

                {/* Feature Points */}
                <div className="space-y-4 mb-12 max-w-2xl mx-auto">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-1 bg-orange-400 rounded"></div>
                    <div className="w-8 h-8 bg-gray-900 text-white rounded-full text-sm font-medium flex items-center justify-center">2</div>
                    <span className="text-white font-medium">Objections, role-playing, closings</span>
                  </div>
                  
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-1 bg-red-400 rounded"></div>
                    <div className="w-8 h-8 bg-gray-900 text-white rounded-full text-sm font-medium flex items-center justify-center">3</div>
                    <span className="text-white font-medium">Personalized coaching strategies</span>
                  </div>
                  
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-1 bg-purple-400 rounded"></div>
                    <div className="w-8 h-8 bg-gray-900 text-white rounded-full text-sm font-medium flex items-center justify-center">4</div>
                    <span className="text-white font-medium">Pep talk sessions</span>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                  <Button size="lg" onClick={handleCallNow} className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 group">
                    <Phone className="w-5 h-5 mr-2" />
                    Call Kevin Now
                    <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                  
                  <Button size="lg" variant="outline" onClick={handleLearnMore} className="border-2 border-white/30 hover:border-white/50 bg-white/10 hover:bg-white/20 text-white px-8 py-4 text-lg font-semibold rounded-lg backdrop-blur-sm transition-all duration-200">
                    Request Call
                  </Button>
                </div>

                {/* Social Proof */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-gray-300">
                  <div className="flex items-center gap-2">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />)}
                    </div>
                    <span className="font-medium">4.9/5 Rating</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Users className="w-5 h-5" />
                    <span>2,500+ Sales Professionals</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <TrendingUp className="w-5 h-5 text-green-400" />
                    <span>35% Average Improvement</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};
export default Voice;